import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderV = _resolveComponent("HeaderV")!
  const _component_SectionOne = _resolveComponent("SectionOne")!
  const _component_SectionTwo = _resolveComponent("SectionTwo")!
  const _component_SectionTrois = _resolveComponent("SectionTrois")!
  const _component_SectionSix = _resolveComponent("SectionSix")!
  const _component_FooterV = _resolveComponent("FooterV")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderV),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_SectionOne),
      _createVNode(_component_SectionTwo),
      _createVNode(_component_SectionTrois),
      _createVNode(_component_SectionSix)
    ]),
    _createVNode(_component_FooterV)
  ], 64))
}